(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lista-espera"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__listaEsperaInit) return;
    window.__listaEsperaInit = true;

    var STORAGE_KEY = 'listaEsperaOk';

    function markDone(root, cursoText) {
      if (!root) return;
      var curso = root.querySelector('[data-lista-espera-curso]');
      if (curso && cursoText) curso.textContent = cursoText;
      var err = root.querySelector('.lista-espera__msg--js-error');
      if (err) err.hidden = true;
      root.hidden = false;
      root.classList.add('is-done');
    }

    function cursoFromTags(root) {
      var tags = root.querySelector('[data-lista-espera-tags]');
      if (!tags) return '';
      var parts = tags.value.split(',');
      var last = parts[parts.length - 1] || '';
      return last.replace(/^LE:\s*/, '');
    }

    // Tras apuntarse, Shopify recarga la página: volvemos a la fecha elegida
    // y mostramos el aviso verde
    function showSuccessAfterReload() {
      if (window.location.search.indexOf('customer_posted=true') === -1) return;
      var saved = null;
      try {
        saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (e) {}
      var params = new URLSearchParams(window.location.search);
      if (saved && saved.variantId && params.get('variant') !== saved.variantId) {
        params.set('variant', saved.variantId);
        window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
        return;
      }
      try {
        window.sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      var root = saved ? document.querySelector('.lista-espera[data-product-id="' + saved.productId + '"]') : null;
      if (!root) {
        var hash = decodeURIComponent(window.location.hash.replace('#', ''));
        var form = hash ? document.getElementById(hash) : null;
        root = form ? form.closest('.lista-espera') : null;
      }
      if (!root) return;
      markDone(root, saved ? saved.curso : '');
      setTimeout(function () {
        root.scrollIntoView({ block: 'center' });
      }, 300);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showSuccessAfterReload);
    } else {
      showSuccessAfterReload();
    }

    // Cambio de variante: actualizar tags, visibilidad y texto del curso
    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var data = detail.data || {};
      var productId = data.newProduct && data.newProduct.id ? data.newProduct.id : data.productId;
      if (!productId) return;
      var variant = detail.resource;

      document.querySelectorAll('.lista-espera[data-product-id="' + String(productId) + '"]').forEach(function (root) {
        if (!variant) {
          root.hidden = true;
          return;
        }
        var productTag = root.dataset.productTag || '';
        var variantTag = String(variant.title || '').replace(/,/g, '').trim();
        var tags = root.querySelector('[data-lista-espera-tags]');
        if (tags) {
          var nuevo =
            'lista-espera,espera-' + variant.id +
            ',LE: ' + productTag +
            ',LE: ' + productTag + ' · ' + variantTag;
          if (tags.value !== nuevo) {
            tags.value = nuevo;
            root.classList.remove('is-done');
            var email = root.querySelector('.lista-espera__email');
            if (email) email.value = '';
            var check = root.querySelector('.lista-espera__consent input');
            if (check) check.checked = false;
          }
        }
        var curso = root.querySelector('[data-lista-espera-curso]');
        if (curso) curso.textContent = productTag + ' · ' + variantTag;
        root.hidden = !!variant.available;
      });
    });

    // Antes de enviar (el envío lo gestiona Shopify con su captcha), guardamos
    // curso y variante para mostrar el aviso verde en la fecha correcta tras recargar
    window.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.classList || !form.classList.contains('lista-espera__form')) return;
        var root = form.closest('.lista-espera');
        var tags = form.querySelector('[data-lista-espera-tags]');
        var variantId = '';
        if (tags) {
          var m = tags.value.match(/espera-(\d+)/);
          if (m) variantId = m[1];
        }
        try {
          window.sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ productId: root.dataset.productId, variantId: variantId, curso: cursoFromTags(root) })
          );
        } catch (e) {}
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
